import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../Footer";

const D280 = () => {
  return (
    <div className="container" style={{ maxWidth: "80%" }}>
      <h1 className="text-center mt-4">
        WGU Course Buffet: All You Can Read 🍽️📖
      </h1>
      <Link type="button" class="btn btn-secondary" to="/courses">
        <i class="fa-solid fa-circle-arrow-left"></i> Buffet Menu
      </Link>

      <h2 className="text-center">You're viewing D280 - JavaScript Programming</h2>

      <div className="card my-4">
        <h4 className="text-center mt-4">
          WGU Course Material : <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
        </h4>
        <h4 className="text-center my-2">Total Time Taken: 16.62 hrs</h4>
        <hr />
        <div className="card-body">
          <p>
            Oh, how much I hated this course! The zybooks material is absolutely
            terrible for this class. There’s so much information in zybooks, it
            feels like they expect you to master JavaScript right away. Anyway,
            I worked through zybooks for about 2 weeks and almost gave up. I
            took a break for a couple of days and then decided to just start the
            PA anyway.
          </p>
          <p>
            The PA is a dynamic Angular web page that makes an API call to show
            information about countries when clicked on. Angular is overwhelming
            when you first start, but I watched this guy’s Angular tutorial on
            YouTube and felt ready to begin coding my PA: Angular Tutorial.
          </p>
          <p>
            After scratching my head over complex code online (you can look this
            course up and see some students’ code on GitHub), I decided to just
            Google how to make an HTTP request API call and see if it works. I
            kid you not… 6 lines of code. Just 6 lines of code were needed to
            make it work. Do you see why I hated this course now? It’s so simple
            — you detect when the mouse clicks on the SVG location and use that
            ID to make an API call. Then you fetch the information and populate
            your frontend. It’s really that easy.
          </p>
          <p>
            If there are any programmers reading this, I think you could
            complete this course in 15 minutes, haha. Anyway, I hosted my
            application to showcase it on my resume. Here’s the link to what the
            app should look like: <a href="https://dynamiccountries.web.app/home" target="_blank" rel="noreferrer">Dynamic Countries App.</a>
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default D280;
